export const environment = {
  name: 'staging',
  production: false,
  withAnimation: true,
  googleTagId: 'not-a-id-only-for-cookie-testing',
  webUrl: 'https://staging.caplock.app',
  serverUrl: 'https://staging.api.caplock.app',
  lastCompilationTime: '2026-03-24T15:01:50.457Z',
  awsRegion: 'eu-west-3',
  awsPictureBucket: 'staging-caplock-picture',
  awsPublicBucket: 'staging-caplock-public',
  userPoolId: 'eu-west-3_nH3aut2dE',
  userPoolWebClientId: '6dcsoatgic5g32j6p9h1usostc',
  identityPoolId: 'eu-west-3:55ca07b3-48f4-487f-ad9e-fd89402c2c9f',
  websocketUrl: 'wss://lqqn09nn82.execute-api.eu-west-3.amazonaws.com/production/',
};
